module.exports = __webpack_public_path__ + "d8abd30f1d836a005a573e142334fab9.png";